<template>
  <WeModal v-on:close="onClose" v-bind:title="getTitle" modal-width="80">
    <div
      slot="body"
      class="pr-3 custom-scrollbar"
      style="max-height: 550px; overflow: auto"
    >
      <div style="min-height: 250px" v-if="loading">
        <WeLoading />
      </div>
      <div v-else v-bind:id="printConfig.id">
        <span v-print="printConfig" ref="printButton"> </span>
        <div class="text-center print">
          <h5 class="font-weight-bold">{{ getFileName }}</h5>
        </div>
        <WeTable
          v-bind:index="false"
          v-bind:columns="columns"
          v-bind:data="detail.list"
          v-bind:exportables="exportables"
          v-on:on-export="onExport"
          v-bind:paginatable="paginatable"
          v-bind:pageDetails="pageDetails"
          v-bind:limitable="limitable"
          v-bind:searchable="searchable"
        />
      </div>
    </div>
  </WeModal>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "UserList",
  props: {
    detail: {
      default: null,
    },
    loading: {
      default: true,
    },
  },
  data() {
    return {
      columns: [
        {
          name: "current_code",
          th: "Cari Hesap Kodu",
          type: "string",
        },
        {
          name: "full_name",
          th: "Ad Soyad",
          type: "string",
        },
        {
          name: "email",
          th: "E-Posta Adersi",
          type: "string",
        },
        {
          name: "cart_amount",
          th: "Alışveriş Miktarı",
          type: "integer",
        },
        {
          name: "total_discount",
          th: "Toplam İndirim Tutarı",
          type: "currency",
        },
      ],
      paginatable: true,
      pageDetails: true,
      limitable: true,
      searchable: true,
      exportables: ["excel", "pdf", "print"],
      printConfig: {
        id: "DiscountCouponUserReport",
        popTitle: "Kupon Kodu Kullanan Üye Listesi",
      },
    };
  },
  methods: {
    ...mapActions("tableExport", ["exportData"]),
    onClose() {
      this.$emit("close");
    },
    onExport(data) {
      if (this.detail.list && this.detail.list.length) {
        if (data.name !== "print") {
          this.exportData({
            route: `report/discount-coupons/${this.detail.id}/users/export`,
            exportable: data,
            fileName: this.getFileName,
            filter: {
              ...this.detail.filter,
              type: data.name,
            },
          });
        } else {
          this.setPrintableSettings(true);
          this.$refs.printButton.click();

          setTimeout(() => {
            this.setPrintableSettings(false);
          }, 100);
        }
      } else {
        this.$swal({
          title: "Dışarı aktarılacak veya Yazdırılacak veri mevcut değil",
          icon: "warning",
          confirmButtonText: "Tamam",
        });
      }
    },
    setPrintableSettings(print = false) {
      this.paginatable = !print;
      this.pageDetails = !print;
      this.limitable = !print;
      this.searchable = !print;

      this.detail.list.sort();
    },
  },
  computed: {
    getTitle() {
      return this.detail.title + " - Üye Listesi";
    },
    getFileName() {
      const defaultName =
        this.detail.title + " Kupon Kodundan Faydalanan Üyeler";
      let result = "";

      if (this.detail.filter.dates) {
        let startDate = this.detail.filter.dates[0];
        let endDate = this.detail.filter.dates[1];

        startDate = new Date(startDate).toLocaleDateString("tr-TR");
        endDate = new Date(endDate).toLocaleDateString("tr-TR");

        result = `${startDate} - ${endDate}_${defaultName}`;
      } else {
        result = defaultName;
      }

      return result;
    },
  },
};
</script>